<div class="xd" *ngIf="issue">
  <!-- All Issues hosts use this header. -->
  <div class="xd-head" [class.xd-head-inline-close]="showClose && !showsAsset" *ngIf="showHeader">
    <!-- The way out that is not a verdict. Until this, a reader who opened a panel to read
         it could only leave by clicking the overlay behind it or by disposing of the Issue,
         and a disposition is not a way to close a window. -->
    <button type="button" class="xd-close" data-e2e="issue-detail-close" *ngIf="showClose && !closeAsCollapse"
            [attr.aria-label]="'@close' | translate" (click)="requestClose()">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
    <!-- Which asset this is. The sheet's drawer opens over a list of many assets, so the
         panel has to say which one — and that is also the way to it.
         No close wiring here on purpose: DrawerService already closes on NavigationStart,
         so a plain click closes the drawer without this asking for it. A modified click
         starts no navigation, so the drawer correctly stays where it is. -->
    <div class="xd-asset" *ngIf="showsAsset">
      <a *ngIf="canLinkAsset" class="xd-asset-link" [routerLink]="assetLink"
         [title]="assetTitle">
        <mat-icon aria-hidden="true">directions_car</mat-icon>
        <span>{{ assetName }}</span>
      </a>
      <span *ngIf="!canLinkAsset" class="xd-asset-plain" [title]="assetTitle">
        <mat-icon aria-hidden="true">directions_car</mat-icon>
        <span>{{ assetName }}</span>
      </span>
    </div>

    <button *ngIf="closeAsCollapse && showClose; else staticHeader" type="button"
            class="xd-header-collapse" data-e2e="issue-header-collapse" aria-expanded="true" (click)="requestClose()">
      <ng-container *ngTemplateOutlet="headerContent"></ng-container>
      <mat-icon class="xd-collapse-icon" aria-hidden="true">expand_less</mat-icon>
    </button>
    <ng-template #staticHeader>
      <ng-container *ngTemplateOutlet="headerContent"></ng-container>
    </ng-template>
    <ng-template #headerContent>
    <span class="xd-head-title">
      <span class="xd-title" [title]="issue.displayName">{{ issue.displayName }}</span>
      <span class="xd-metric">
        <span class="xd-metric-label">{{ '@severity' | translate }}</span>
        <app-severity-tag [severity]="issue.severity" variant="detail"></app-severity-tag>
      </span>
      <span class="xd-metric">
        <span class="xd-metric-label">{{ '@issuesColConfidence' | translate }}</span>
        <span class="xd-conf" [class.muted]="confidenceMuted">{{ confidencePct }}%</span>
      </span>
    </span>
    <span class="xd-desc" *ngIf="issue.description">{{ issue.description }}</span>
    <span class="xd-head-sub">
      <app-lifecycle-chip [state]="issue.lifecycleState"></app-lifecycle-chip>
      <span class="cc-sep">·</span>
      <span>{{ '@issueLastDetected' | translate: { time: (lastFiredUtc | issueTime) } }}</span>
      <span class="cc-sep">·</span>
      <span>{{ (evidenceGroups.length === 1 ? '@issueSignalCountOne' : '@issueSignalCount') | translate: { count: evidenceGroups.length } }}</span>
      <app-issue-tags [reopened]="reopened" [dvirOrigin]="dvirOrigin"></app-issue-tags>
    </span>

    </ng-template>

    <!-- Where the asset is now, and the way to see it on a map. The drawer opens over a
         list of many assets, so the one it shows has to be placed as well as named. -->
    <div class="xd-loc" *ngIf="showLocationRow" data-e2e="issue-location">
      <mat-icon class="xd-loc-pin" aria-hidden="true">place</mat-icon>
      <span class="xd-loc-text">
        <!-- A name the sheet could not place reads "unknown" only while there is no
             position to show instead; beside a live position time it would contradict it. -->
        <span class="xd-loc-name" *ngIf="locationText || !positionAtUtc" [title]="locationText || ('@issueLocationUnknown' | translate)">{{ locationText || ('@issueLocationUnknown' | translate) }}</span>
        <ng-container *ngIf="positionAtUtc">
          <span class="cc-sep" *ngIf="locationText">·</span>
          <span class="xd-loc-time">{{ '@issuePositionAgo' | translate: { time: (positionAtUtc | issueTime) } }}</span>
        </ng-container>
      </span>
      <button type="button" class="fhd-btn xd-loc-map" data-e2e="issue-view-map" (click)="openMap()">
        <mat-icon aria-hidden="true">map</mat-icon>
        <span>{{ '@issueViewOnMap' | translate }}</span>
      </button>
    </div>
  </div>

  <button type="button" class="xc-coord-toggle xc-details-toggle" data-e2e="details-toggle"
          *ngIf="collapsibleBody" (click)="bodyOpen = !bodyOpen">
    <svg class="xc-caret" [class.open]="bodyOpen" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" stroke-width="2.5" aria-hidden="true">
      <polyline points="9 18 15 12 9 6" />
    </svg>
    <span class="xc-coord-title">{{ '@details' | translate }}</span>
  </button>

  <ng-container *ngIf="bodyVisible">
  <!-- Reopen strip -->
  <div class="xc-reopen" *ngIf="reopened">
    {{ '@issueReopenedLabel' | translate }} — {{ '@issueReopenedBody' | translate: { count: issue.reopenCount } }}
  </div>

  <!-- How the Issue got here. The header gives one number; this says whether the
       number is climbing or falling, and what moved it. -->
  <div class="xc-section" *ngIf="series && showConfidenceChart">
    <div class="xc-section-label">{{ '@issueConfidenceOverTime' | translate }}</div>
    <app-confidence-chart [series]="series" [alertHits]="alertHits" [showDots]="!drawerLayout" [showSeverity]="!drawerLayout"></app-confidence-chart>
    <div class="xc-alert-hits-status" *ngIf="alertHitsStatus" role="status">
      {{ alertHitsStatus | translate: { count: alertHits.length } }}
    </div>
  </div>

  <!-- Everything the bus reported, not only what built this Issue. Outlined rather than
       filled: it opens a reference view, and the filled buttons here change the Issue. -->
  <div class="xc-section xc-faults" *ngIf="canShowFaults">
    <button type="button" class="fhd-btn xc-faults-btn" data-e2e="issue-faults"
            (click)="openFaultHistory()">
      <mat-icon aria-hidden="true">show_chart</mat-icon>
      <span class="xc-faults-label">{{ '@issueFaultHistoryOpen' | translate }}</span>
      <mat-icon class="xc-faults-go" aria-hidden="true">chevron_right</mat-icon>
    </button>
  </div>

  <!-- Contributing signals. Evidence is what makes an Issue actionable; a severity
       number with nothing behind it is not. -->
  <div class="xc-section" *ngIf="evidenceGroups.length">
    <div class="xc-section-label">{{ '@issueContributingSignals' | translate }}</div>
    <app-evidence-card *ngFor="let g of evidenceGroups" [contribution]="g.representative"
                       [occurrences]="g.occurrences"
                       [reporterName]="reporterNames[g.representative.contributionId] || null"
                       [assetFaults]="assetFaults"
                       (openSource)="onOpenSource($event)"></app-evidence-card>
  </div>

  <!-- A seeded panel knows its header before the read returns. Saying the evidence is
       on its way beats an empty section that reads as "no signals". -->
  <div class="xc-section" *ngIf="!loaded && !evidenceGroups.length">
    <div class="xc-section-label">{{ '@issueContributingSignals' | translate }}</div>
    <div class="xc-shimmer" aria-hidden="true"></div>
    <div class="xc-shimmer" aria-hidden="true"></div>
    <div class="xc-shimmer short" aria-hidden="true"></div>
  </div>

  <div class="xc-divider" *ngIf="showCoordination"></div>

  <!-- Coordination: the embedded case workflow and, in the classic layout, the issue's own
       activity. The whole section goes when it would hold nothing: a header over an empty
       band reads as a section that failed to load. -->
  <div class="xc-section" *ngIf="showCoordination">
    <button type="button" class="xc-coord-toggle" data-e2e="coordination-toggle" (click)="toggleCoordination()">
      <svg class="xc-caret" [class.open]="coordinationOpen" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2.5" aria-hidden="true">
        <polyline points="9 18 15 12 9 6" />
      </svg>
      <span class="xc-coord-title">{{ '@issueCoordination' | translate }}</span>
    </button>

    <div *ngIf="coordinationOpen" class="xc-coord-body">
      <!-- The case workflow is a form, so it goes when the Issue is history. Its own
           canEdit reads the MaintainVehicle right and knows nothing about the Issue being
           closed, so without this a closed Issue still offers a case to open or reassign.
           It goes with the tenant's cases feature too: without it there is no case to
           open, and the section holds the activity alone. A reader without the right to
           create a case sees the panel only when a case already exists. -->
      <app-alert-case *ngIf="showCasePanel" [context]="caseContext" [preload$]="case$"
                      [embedded]="true"
                      (caseWritten)="caseChanged.emit($event)"></app-alert-case>

      <!-- Issue activity (lifecycle, disposition, reopen), newest at the bottom. The
           classic layout keeps it here; the drawer gives it a section of its own below. -->
      <div class="xc-timeline" *ngIf="!drawerLayout && timeline.length">
        <div class="mini-event" *ngFor="let e of timeline" [class.notable]="e.notable">
          <div class="mini-event-text">
            {{ e.textKey | translate: e.textParams }}
            <span class="mini-event-actor" *ngIf="e.actorName">· {{ e.actorName }}</span>
          </div>
          <div class="mini-event-time">{{ e.atUtc | issueTime }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- The issue's own history, apart from the case. A reader asked what the issue did
       and what people did about it as two questions, so they are two sections, and this
       one stays when the tenant has no cases at all. -->
  <div class="xc-divider" *ngIf="showIssueHistory"></div>
  <div class="xc-section xc-history" *ngIf="showIssueHistory" data-e2e="issue-history">
    <div class="xc-section-label xc-label-drawer">{{ '@issueHistory' | translate }}</div>
    <div class="xc-timeline xc-timeline-drawer">
      <div class="mini-event mini-event-drawer" *ngFor="let e of timeline" [class.notable]="e.notable">
        <div class="mini-event-text">
          {{ e.textKey | translate: e.textParams }}
          <span class="mini-event-actor" *ngIf="e.actorName">· {{ e.actorName }}</span>
        </div>
        <div class="mini-event-time">{{ e.atUtc | issueTime }}</div>
      </div>
    </div>
  </div>

  </ng-container>

  <!-- Disposition in one click. The note is offered, never demanded: it is optional in
       the API, and a prompt most people confirm empty costs every user a click while
       buying an empty string. Typing in it is free; ignoring it is free. Mark fixed is
       the loud one, because the common case should not cost a decision. -->
  <div class="xc-footer" *ngIf="canMaintain">
    <!-- The note is typed data rather than a filter, so it is named by a label that stays
         on screen and not by a placeholder that leaves on the first keystroke. -->
    <label class="xc-note-label" for="xc-note">{{ '@issueNoteLabel' | translate }}</label>
    <input class="fhd-filter-input xc-note" id="xc-note" type="text" autocomplete="off"
           data-e2e="disposition-note"
           [(ngModel)]="dispositionNote" />
    <!-- Every verdict below closes the Issue. Said once, above the row, rather than pressed
         into three labels - and left out of two of them, which is what happened before. -->
    <div class="xc-closeas-label" *ngIf="!drawerLayout">{{ '@issueCloseAsLabel' | translate }}</div>
    <div class="xc-foot-idle" *ngIf="!drawerLayout">
      <button type="button" class="fhd-btn fhd-btn-primary xc-verdict" data-e2e="disposition-mark-fixed"
              [disabled]="submitting" (click)="dispose(DispositionTypes.RealAndFixed)">
        {{ '@issueMarkAsFixedShort' | translate }}
      </button>
      <button type="button" class="fhd-btn xc-verdict" data-e2e="disposition-false-positive"
              [disabled]="submitting" (click)="dispose(DispositionTypes.FalsePositive)">
        {{ '@issueDispositionFalsePositiveShort' | translate }}
      </button>
      <button type="button" class="fhd-btn xc-verdict" data-e2e="disposition-dismiss"
              [disabled]="submitting" (click)="dispose(DispositionTypes.Dismissed)">
        {{ '@issueDispositionDismissShort' | translate }}
      </button>
    </div>

    <!-- The drawer: three verdicts, each a whole phrase, stacked when space is limited. Fixed is the
         common case and keeps the primary look; the phrase on it says it is an action. -->
    <div class="xc-closeas-label xc-closeas-drawer" *ngIf="drawerLayout">{{ '@issueCloseThisIssue' | translate }}</div>
    <div class="xc-foot-idle xc-foot-drawer" *ngIf="drawerLayout">
      <button type="button" class="fhd-btn fhd-btn-primary xc-verdict xc-verdict-eq" data-e2e="disposition-mark-fixed"
              [disabled]="submitting" (click)="dispose(DispositionTypes.RealAndFixed)">
        {{ '@issueCloseAsFixed' | translate }}
      </button>
      <button type="button" class="fhd-btn xc-verdict xc-verdict-eq" data-e2e="disposition-false-positive"
              [disabled]="submitting" (click)="dispose(DispositionTypes.FalsePositive)">
        {{ '@issueCloseAsFalsePositive' | translate }}
      </button>
      <button type="button" class="fhd-btn xc-verdict xc-verdict-eq" data-e2e="disposition-dismiss"
              [disabled]="submitting" (click)="dispose(DispositionTypes.Dismissed)">
        {{ '@issueCloseNoAction' | translate }}
      </button>
    </div>
  </div>
</div>
